// ESGVerificationDashboard.jsx
import React from "react";
import "./ESGVerificationDashboard.css";

const ESGVerificationDashboard = () => {
  const rows = [
    {
      category: "Global Standards",
      metrics: "GRI (90% mapped), SASB (75% sector coverage), CDP/TCFD (climate risks included), SDG links",
      status: "Partial Compliance",
      statusType: "warning",
      flag: "SASB KPIs missing for Scope 3; SDG mapping inconsistent",
      action: "Clarify KPI scope with reporting team",
    },
    {
      category: "Legal & Regulatory",
      metrics: "Country ESG laws (90%), OHS permits (80%), Labor compliance (100%), Environmental (85%)",
      status: "Mostly Compliant",
      statusType: "good",
      flag: "Gap in waste regulation reporting; missing OHS permit evidence",
      action: "Upload permit documents & confirm local waste logs",
    },
    {
      category: "Sector-Specific Norms",
      metrics: "Mining: ICMM Tailings (95%), Energy: GHG intensity metrics (80%), Construction IFC PS1-8 (70%)",
      status: "Gaps Noted",
      statusType: "warning",
      flag: "Missing tailings monitoring trend; GHG baseline inconsistent",
      action: "Verify mining logs, reconcile GHG calculations",
    },
    {
      category: "Other Commitments",
      metrics: "IFC PS (85%), OECD (90%), Corporate Code of Conduct (100%), Green Bonds KPIs (70%)",
      status: "Partial Compliance",
      statusType: "warning",
      flag: "Green Bond KPIs incomplete; IFC PS6 biodiversity offset missing",
      action: "Add offset documentation, validate bond KPI disclosure",
    },
    {
      category: "Data Validation",
      metrics: "95% aligned with previous year; 2 anomalies flagged (emissions, water withdrawals)",
      status: "Review Required",
      statusType: "warning",
      flag: "Water data unusually low vs. historical; emission drop unexplained",
      action: "Require explanation + corrective action plan",
    },
    {
      category: "Evidence Validation",
      metrics: "88% evidence attached (certificates, photos, minutes, logs)",
      status: "Incomplete",
      statusType: "bad",
      flag: "3 missing calibration certificates; 2 unsigned training logs",
      action: "Upload missing evidence & verify authenticity",
    },
    {
      category: "Consistency Check",
      metrics: "92% consistent (units, terminology, benchmarks)",
      status: "Largely Compliant",
      statusType: "good",
      flag: "Some CO₂ emissions reported in ppm instead of tCO₂e",
      action: "Standardize reporting units",
    },
    {
      category: "Historical / Benchmarking",
      metrics: "Compared vs. last 3 years: emissions ↓15%, waste ↓10%, biodiversity offset unchanged",
      status: "Mixed Results",
      statusType: "warning",
      flag: "Decline in emissions not justified with operational changes",
      action: "Require explanation in variance analysis",
    },
    {
      category: "Verification Readiness Score",
      metrics: "82% (14 issues flagged; 4 critical, 10 moderate)",
      status: "Not Ready for Final Approval",
      statusType: "bad",
      flag: "Needs corrective evidence, recalculation, and clarification",
      action: "Escalate gaps to responsible leads",
    },
    {
      category: "Final Verifier Comments",
      metrics: "“Overall framework aligned but evidence gaps and inconsistent benchmarking remain. Needs corrections before approval.”",
      status: "—",
      statusType: "good",
      flag: "—",
      action: "Decision pending corrections",
    },
  ];

  return (
    <div className="dashboard">
      <h1 className="title">ESG Verification Dashboard – High-Level Snapshot</h1>

      {/* Main Table */}
      <div className="table-wrapper">
        <table className="esg-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Key Metrics / Indicators</th>
              <th>Verification Status</th>
              <th>AI Insights / Flags</th>
              <th>Management Action Required</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx} className={idx % 2 === 0 ? "even" : "odd"}>
                <td className="category">
                  <span className="example">Example:</span>
                  {row.category}
                </td>
                <td className="metrics">{row.metrics}</td>
                <td className="status-col">
                  <span className={`status-icon ${row.statusType}`}></span>
                  <span className="status-text">{row.status}</span>
                </td>
                <td className="flag">{row.flag}</td>
                <td className="action">{row.action}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      
      {/* Pulsing red dot */}
      <div className="pulse-dot"></div>
    </div>
  );
};

export default ESGVerificationDashboard;